<template>
    <div class="grid-content">
        <div class="grid-item grid-item-half grid-item-break-half">
            <v-select
                label="Authorization Type"
                v-model="cred.auth.type"
                :options="authorizationOptions"/>
        </div>
        <template v-if="cred.auth.requiresCredentials">
            <div class="grid-item grid-item-half grid-item-break-half">
                <r-input
                    label="Username"
                    auto-complete="username"
                    v-model="cred.auth.username"
                    :validate="$v.cred.auth.username"/>
            </div>
            <div class="grid-item grid-item-half">
                <r-input
                    label="Password"
                    auto-complete="password"
                    v-model="cred.auth.password"
                    password
                    :validate="$v.cred.auth.password"/>
            </div>
        </template>
        <div class="grid-item grid-item-half grid-item-break-half">
            <r-input
                label="Host"
                v-model="cred.host"
                :validate="$v.cred.host"
                help-text="e.g. mail.rebilly.com"/>
        </div>
        <div class="grid-item grid-item-half">
            <r-input
                label="Port"
                v-model="cred.port"
                :validate="$v.cred.port"
                help-text="e.g. 465"/>
        </div>
        <div class="grid-item grid-item-half grid-item-break-half">
            <v-select
                label="Encryption Type"
                v-model="cred.encryption"
                :options="encryptionOptions"/>
        </div>
    </div>
</template>

<script>
    import EmailCredentialModel, {EmailAuthorizationModel} from '@/common/models/email-credential-model';
    import {vSelect} from '@/components/form';
    import {numeric, required} from 'vuelidate/lib/validators';
    import BaseCredentials from './base-credentials';

    const authorizationOptions = [
        {
            label: 'No Login',
            value: EmailAuthorizationModel.Types.none,
        },
        {
            label: 'Plain Text',
            value: EmailAuthorizationModel.Types.plain,
        },
        {
            label: 'Secure Login',
            value: EmailAuthorizationModel.Types.login,
        },
        {
            label: 'CRAM MD5',
            value: EmailAuthorizationModel.Types.cramMD5,
        },
    ];

    const encryptionOptions = [
        {
            label: 'None',
            value: EmailCredentialModel.SMTPEncryptions.none,
        },
        {
            label: 'SSL',
            value: EmailCredentialModel.SMTPEncryptions.ssl,
        },
        {
            label: 'TLS',
            value: EmailCredentialModel.SMTPEncryptions.tls,
        },
    ];

    export default {
        name: 'smtp',
        extends: BaseCredentials,
        components: {vSelect},
        data() {
            return {
                authorizationOptions,
                encryptionOptions,
            };
        },
        validations() {
            const base = {
                cred: {
                    port: {required, numeric},
                    host: {required},
                },
            };
            if (this.cred.auth.requiresCredentials) {
                base.cred.auth = {
                    username: {required},
                    password: {required},
                };
            }
            return base;
        },
        methods: {
            getValidationAggregate() {
                return {
                    name: 'smtp',
                    beforeValidation: () => this.isActiveType && this.$v.$touch(),
                    rules: () => {
                        if (!this.isActiveType) {
                            return [];
                        }
                        const rules = [
                            {
                                name: `The SMTP port is required and it must be numeric.`,
                                delegate: () => this.$v.cred.port.$error,
                            },
                            {
                                name: `The SMTP host is required.`,
                                delegate: () => this.$v.cred.host.$error,
                            },
                        ];
                        if (this.cred.auth.requiresCredentials) {
                            return rules.concat([
                                {
                                    name: `The SMTP authorization username is required.`,
                                    delegate: () => this.$v.cred.auth.username.$error,
                                },
                                {
                                    name: `The SMTP authorization password is required.`,
                                    delegate: () => this.$v.cred.auth.password.$error,
                                },
                            ]);
                        }
                        return rules;
                    },
                };
            },
        },
    };
</script>
